import { calendarDate } from '../../../utils/date-time';
import { api } from '../../../AxiosConfig';

class AgendaClienteService {
    createAgendamento(agendamentoData: {
        estabId: string;
        startAt?: Date;
        localDate?: string;
        servicoId: string;
        servicosExtrasIds?: string[];
        attendantId: string;
        startMinutes: number;
        customerCpfCnpj?: string;
    }) {
        return api.post(`/horarios/cliente/agendar`, agendamentoData);
    }

    getHorarios(estabId: string, data: Date, servicoId: string, atendenteId: string, duration?: number, horarioId?: string) {
        const params: any = {
            estabId,
            data: calendarDate(data),
            servicoId,
            atendenteId,
            horarioId
        }

        if (!!duration) {
            params.duration = duration;
        }

        return api.get(`/horarios`, { params });
    }

    cancel(horarioId: string) {
        return api.post(`/horarios/cliente/cancel`, { horarioId });
    }

    confirm(horarioId: string) {
        return api.post(`/horarios/cliente/confirm`, { horarioId });
    }

    getAgendamentosCards() {
        return api.get(`/horarios/cliente/cards`);
    }

    getUltimoAgendamentoByEstab(estabId: string) {
        return api.get('/horarios/cliente/ultimo', { params: { estabId } });
    }
}

export { AgendaClienteService };
